import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import CreateTeamPopUp from '@features/crm/brands/components/CreateTeamPopUp';
import SearchebleSelect from '@features/crm/brands/components/SearchebleSelect';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchTeamBrands, fetchUserByEmail } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

const BrnadList = ({ onTabChange }) => {
	const dispatch = useDispatch();

	const [brandList, setBrandList] = useState([]);
	const [userList, setUserList] = useState([]);
	const [isCreate, setIsCreate] = useState(false);
	const [totalBuyer, setTotalBuyer] = useState(0);
	const [seledtedData, setSelectedData] = useState(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [isearchClicked, setIsSearchClicked] = useState(true);

	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		onFetchBrandList();
		searchUserByEmail(true);
	}, []);

	const onFetchBrandList = async () => {
		setBrandList(await fetchTeamBrands(`${id}?withMemberCount=true`));
	};

	const onDelete = async (id) => {
		try {
			dispatch(openLoader());
			await ApiClient.DELETE('getTeamBrands', {}, `${id}`);
			onFetchBrandList();
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	useEffect(() => {
		if (!searchTerm) {
			return;
		}
		const timeout = setTimeout(() => {
			searchUserByEmail(false);
		}, 500);
		return () => clearTimeout(timeout);
	}, [searchTerm]);

	const searchUserByEmail = async (isInitialCall) => {
		let params = `?page=0&size=100&brandId=${id}&email=${searchTerm}`;
		let response = await fetchUserByEmail(params);
		const filtered = response?.map((item) => {
			return { ...item, label: item?.name, value: item?.id };
		});
		if (isInitialCall) {
			setTotalBuyer(filtered?.length);
		}
		setUserList(filtered);
	};

	return (
		<div className="tab-contents">
			<div className="d-flex justify-content-between align-items-center mb-12">
				<h3 className="semibold-16 mb-0">Total Buyer : {totalBuyer}</h3>
				<div className="d-flex align-items-center">
					<div className="form-group size32 m-0 search-filter filter-with-animation">
						<div
							className={
								isearchClicked ? 'with-icon right-icon hidden' : 'with-icon right-icon'
							}
						>
							<SearchebleSelect
								isLoading={false}
								options={userList}
								onSelect={(item) => navigate(`/clients/edit/${item?.id}`)}
								onSearch={(value) => setSearchTerm(value)}
								selectedValue={searchTerm}
								placeholder={'Name'}
								isSearchIconClicked={!isearchClicked}
								isFromTeamPage={true}
							/>

							<span className="right-icon" onClick={() => setIsSearchClicked(!isearchClicked)}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={23}
									height={22}
									viewBox="0 0 23 22"
									fill="none"
								>
									<path
										d="M10.543 16.5C14.3399 16.5 17.418 13.422 17.418 9.625C17.418 5.82804 14.3399 2.75 10.543 2.75C6.74601 2.75 3.66797 5.82804 3.66797 9.625C3.66797 13.422 6.74601 16.5 10.543 16.5Z"
										stroke="#21242B"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M19.2526 18.3346L15.5859 14.668"
										stroke="#21242B"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</span>
						</div>
					</div>
					<button
						className="button text ml-12 d-flex align-items-center"
						onClick={() => setIsCreate(true)}
					>
						<img
							src={`${process.env.PUBLIC_URL}/icons/add-round.svg`}
							alt="add"
							className="mr-1"
						/>
						<span className="mr-1 gray_dark_01 text-nowrap">Create team</span>
					</button>
				</div>
			</div>
			<table className="table with-border">
				<thead>
					<tr>
						<th>Team Name</th>
						<th>Department</th>
						<th>Team created</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{brandList?.map((item) => (
						<tr key={item?.id}>
							<td className="cursor-pointer" onClick={() => onTabChange(item)}>
								<p className="gray_dark_01">
									{item?.name} ({item?.memberCount || 0})
								</p>
							</td>
							<td className="cursor-pointer" onClick={() => onTabChange(item)}>
								{item?.departmentName}
							</td>
							<td className="cursor-pointer" onClick={() => onTabChange(item)}>
								{changeDateFormat(item?.creationDate, '', 'DD MMM, YYYY')}
							</td>
							<td>
								<div className="option">
									<div className="dropdown">
										<button
											className="btn btn-default dropdown-toggle"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="true"
										>
											<img
												src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
												alt="more"
											/>
										</button>
										<ul
											className="dropdown-menu dropdown-menu-right shadow-lg "
											role="menu"
											aria-labelledby="menu1"
										>
											<li
												onClick={() => {
													setSelectedData(item);
													setIsCreate(true);
												}}
											>
												<span>Edit</span>
											</li>
											<li onClick={() => onDelete(item?.id)}>
												<span>Delete</span>
											</li>
										</ul>
									</div>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{isCreate && (
				<CreateTeamPopUp
					onClose={() => {
						onFetchBrandList();
						setIsCreate(false);
						setSelectedData(null);
					}}
					brandId={id}
					seledtedData={{
						name: seledtedData?.name,
						brandDepartment: seledtedData?.departmentName?.toUpperCase()
					}}
					editId={seledtedData?.id || null}
				/>
			)}
		</div>
	);
};

export default BrnadList;
